<mat-card>
  <h2 translate>paymentReports.title</h2>
  <p translate>paymentReports.text</p>

  <mat-card-content>
    <form [formGroup]="searchDataForm">
      <div fxFlex fxLayout="row wrap" class="form-wrapper">
        <div fxFlex="100" fxFlex.gt-sm="50" *ngIf="isMacroChainUser || isBusinessDirector">
          <scf-custom-select-search
            fxFlex="100"
            formControlName="macroChain"
            [id]="'macroChainSelect'"
            [dataInput]="macroChainList"
            [placeholder]="'macrouser.title.groups'"
            [isRequired]="true"
            [showErrors]="searchDataForm?.controls?.macroChain?.errors"
          >
          </scf-custom-select-search>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="50" *ngIf="isMacroOfficeUser || isBusinessDirector">
          <scf-custom-select-search
            fxFlex="100"
            formControlName="macroOffice"
            [id]="'macroOfficeSelect'"
            [dataInput]="macroOfficeList"
            [placeholder]="'macrouser.title.offices'"
            [isRequired]="true"
            [showErrors]="searchDataForm?.controls?.macroOffice?.errors"
          >
          </scf-custom-select-search>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="100" *ngIf="isMacroChainUser || isMacroOfficeUser"></div>
        <mat-checkbox fxFlex="100" class="monthCheckBox" (change)="sendDateMonth($event)">
          <mat-label translate>sidenav.menu.reports.current-month</mat-label>
        </mat-checkbox>
        <div fxFlex="50" fxFlex.gt-sm="20">
          <mat-form-field appearance="outline">
            <mat-label translate>paymentReports.initialDate</mat-label>
            <input
              #inputInitialDate
              id="initialDateInput"
              matInput
              [matDatepicker]="datepickerInitialDate"
              formControlName="initialDate"
              [min]="minDate"
              [max]="currentDate"
              autocomplete="off"
            />
            <mat-datepicker-toggle matSuffix [for]="datepickerInitialDate"></mat-datepicker-toggle>
            <mat-datepicker id="initialDatePicker" startView="multi-year" #datepickerInitialDate></mat-datepicker>
            <mat-error *ngIf="searchDataForm.controls.initialDate.errors?.required" translate>
              field.required
            </mat-error>
            <mat-error *ngIf="searchDataForm.controls.initialDate.errors?.dateFuture" translate>
              field.error.dateFuture
            </mat-error>
            <mat-error *ngIf="searchDataForm.errors?.dateInvalid" translate>field.error.dateInitial</mat-error>
          </mat-form-field>
        </div>

        <div fxFlex="50" fxFlex.gt-sm="20">
          <mat-form-field appearance="outline">
            <mat-label translate>paymentReports.endDate</mat-label>
            <input
              #inputFinalDate
              id="finalDateInput"
              matInput
              [matDatepicker]="datepickerFinalDate"
              formControlName="finalDate"
              [min]="searchDataForm.controls.initialDate?.value"
              [max]="currentDate"
              autocomplete="off"
            />
            <mat-datepicker-toggle matSuffix [for]="datepickerFinalDate"></mat-datepicker-toggle>
            <mat-datepicker id="finalDateInputpicker" startView="multi-year" #datepickerFinalDate></mat-datepicker>
            <mat-error *ngIf="searchDataForm.controls.finalDate.errors?.required" translate> field.required </mat-error>
            <mat-error *ngIf="searchDataForm.errors?.dateInvalid" translate>field.error.dateFinal</mat-error>
            <mat-error *ngIf="searchDataForm.controls.finalDate.errors?.dateFuture" translate>
              field.error.dateFuture
            </mat-error>
          </mat-form-field>
        </div>

        <div fxFlex="40" fxFlex.gt-sm="25">
          <scf-custom-select-search
            [id]="'prescriptorSelect'"
            formControlName="prescriptor"
            fxFlex="100"
            [dataInput]="prescriptorsList"
            [placeholder]="'paymentReports.selectPrescriptor'"
            [isRequired]="true"
            [isMultiple]="true"
            (onSelectCheckAll)="setCheckAll($event)"
            [showErrors]="searchDataForm?.controls?.prescriptor?.errors"
          >
          </scf-custom-select-search>
        </div>

        <div fxFlex="60" fxFlex.gt-sm="35">
          <scf-custom-select-search
            [id]="'establishmentSelect'"
            formControlName="establishment"
            fxFlex="100"
            [dataInput]="establishmentsList"
            [placeholder]="'paymentReports.selectEstablishment'"
            [isRequired]="true"
            [isMultiple]="true"
            (onSelectCheckAll)="setCheckAll($event)"
            [showErrors]="searchDataForm?.controls?.establishment?.errors"
          >
          </scf-custom-select-search>
        </div>
      </div>
    </form>
    <div class="form-wrapper">
      <div fxLayoutAlign="end" class="button-padding">
        <button
          id="searchPaymentReports"
          mat-flat-button
          type="button"
          color="accent"
          (click)="onSearchClick(1)"
          [disabled]="this.searchDataForm.invalid"
        >
          <span>{{ 'paymentReports.btnConsult' | translate | uppercase }}</span>
        </button>
      </div>
    </div>
  </mat-card-content>
</mat-card>
<mat-card class="card-info-padding" *ngIf="reports && reports.results.length > 0">
  <div fxFlex="40">
    <h2 translate>paymentReports.infoPayments.title</h2>
    <p translate>paymentReports.infoPayments.text</p>
  </div>
  <div fxFlex="60" class="card-info-row">
    <div fxFlex="50" class="card-info-row">
      <div>
        <h2 class="noBold" translate>paymentReports.infoPayments.paymentsDone</h2>
      </div>
      <div>
        <h2>{{ reports.realizedPayments }}</h2>
      </div>
    </div>
    <div fxFlex="50" class="card-info-row">
      <div>
        <h2 class="noBold" translate>paymentReports.infoPayments.totalImport</h2>
      </div>
      <div>
        <h2>{{ reports.amountTotal | transformNumber | transformEuroCurrency }}</h2>
      </div>
    </div>
  </div>
</mat-card>

<mat-card *ngIf="reports">
  <!-- HEADER -->
  <div
    class="panel-request__card-header"
    *ngIf="reports && reports.results.length > 0"
    fxLayout="row wrap"
    fxLayoutAlign="space-between center"
  >
    <h2 class="panel-request__card-header--title" translate>paymentReports.results</h2>
    <div fxFlex fxLayout="row" fxLayoutAlign="start center" fxLayoutAlign.gt-xs="end center" fxLayoutGap="16px">
      <button id="createExcelPanel" mat-stroked-button color="accent" (click)="createExcel()">
        <mat-icon class="icon-ic_file_download"></mat-icon>
        <span>{{ 'button.exportExcel' | translate | uppercase }}</span>
      </button>
      <button id="createPdfPanel" mat-stroked-button color="accent" (click)="createPdf()">
        <mat-icon class="icon-ic_print"></mat-icon>
        <span>{{ 'button.print' | translate | uppercase }}</span>
      </button>
    </div>
  </div>

  <!-- CONTENT -->
  <mat-card-content>
    <div *ngIf="reports && dataSource.data?.length > 0; else noOperations" class="table__wrapper">
      <!-- TABLE -->
      <table aria-label="reports" mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="digitalsignature">
          <th mat-header-cell *matHeaderCellDef translate></th>
          <td mat-cell *matCellDef="let element">
            <mat-icon
              class="icon-ic_sign"
              *ngIf="element.digitalSignature == 'L' || element.digitalSignature == 'B'"
            ></mat-icon>
          </td>
        </ng-container>
        <ng-container matColumnDef="code">
          <th mat-header-cell *matHeaderCellDef translate>paymentReports.results.code</th>
          <td mat-cell *matCellDef="let element">{{ element.contractId }}</td>
        </ng-container>
        <ng-container matColumnDef="operative">
          <th mat-header-cell *matHeaderCellDef translate>paymentReports.results.operative</th>
          <td mat-cell *matCellDef="let element">{{ element.operative }}</td>
        </ng-container>
        <ng-container matColumnDef="paymentDate">
          <th mat-header-cell *matHeaderCellDef translate>paymentReports.results.paymentDate</th>
          <td mat-cell *matCellDef="let element">{{ element.paymentDate }}</td>
        </ng-container>
        <ng-container matColumnDef="beneficiary">
          <th mat-header-cell *matHeaderCellDef translate>paymentReports.results.beneficiary</th>
          <td mat-cell *matCellDef="let element">{{ element.recipient }}</td>
        </ng-container>
        <ng-container matColumnDef="import">
          <th mat-header-cell *matHeaderCellDef translate>paymentReports.results.import</th>
          <td mat-cell *matCellDef="let element">{{ element.amount | transformNumber }}</td>
        </ng-container>
        <ng-container matColumnDef="holder">
          <th mat-header-cell *matHeaderCellDef translate>paymentReports.results.holder</th>
          <td mat-cell *matCellDef="let element">{{ element.titleholder }}</td>
        </ng-container>
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef translate>paymentReports.results.description</th>
          <td mat-cell *matCellDef="let element">{{ element.description }}</td>
        </ng-container>
        <ng-container matColumnDef="lot">
          <th mat-header-cell *matHeaderCellDef translate>paymentReports.results.lot</th>
          <td mat-cell *matCellDef="let element">{{ element.lot }}</td>
        </ng-container>
        <ng-container matColumnDef="printPayment">
          <th mat-header-cell *matHeaderCellDef class="mat-header-cell--actions"></th>
          <td mat-cell *matCellDef="let element" class="mat-cell--buttons">
            <button
              id="iconPrintPayment"
              mat-stroked-button
              class="mat-cell__buttons"
              (click)="onClickPrintPayment(element)"
            >
              <mat-icon class="icon-ic_payment-sheet"></mat-icon>
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      <mat-paginator
        hidePageSize
        [pageSize]="15"
        *ngIf="reports.realizedPayments > 15 && !isAllChecked()"
        showFirstLastButtons
      ></mat-paginator>
      <div fxLayout="row" class="buttons-paginator" *ngIf="reports.numPages > 1 && isAllChecked()">
        <button
          id="previousPageRequestPanel"
          mat-flat-button
          class="panel-request__card-footer--buttons"
          (click)="onSearchClick(1)"
          [disabled]="page == 1"
        >
          <mat-icon [class]="'icon-ic_to_beginning'"></mat-icon>
        </button>
        <button
          id="previousPageRequestPanel"
          mat-flat-button
          class="panel-request__card-footer--buttons"
          (click)="onSearchClick(page - 1)"
          [disabled]="page == 1"
        >
          <mat-icon [class]="'icon-ic_chevron_left'"></mat-icon>
        </button>
        <button
          id="nextPageRequestPanel"
          mat-flat-button
          class="panel-request__card-footer--buttons"
          (click)="onSearchClick(page + 1)"
          [disabled]="page == reports.numPages"
        >
          <mat-icon [class]="'icon-ic_chevron_right'"></mat-icon>
        </button>
        <button
          id="previousPageRequestPanel"
          mat-flat-button
          class="panel-request__card-footer--buttons"
          (click)="onSearchClick(reports.numPages)"
          [disabled]="page == reports.numPages"
        >
          <mat-icon [class]="'icon-ic_to_end'"></mat-icon>
        </button>
      </div>
    </div>

    <ng-template #noOperations>
      <div fxLayout="column" fxLayoutAlign="center center" class="invest-detail__card">
        <mat-label class="panel-request__label-no-operation" translate>investDetail.noOperations</mat-label>
      </div>
    </ng-template>
  </mat-card-content>
</mat-card>
